var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.917,
    d: "M17.2 26.667v-1.984a3.967 3.967 0 0 0-3.966-3.967H5.3a3.967 3.967 0 0 0-3.967 3.967v1.984m25.334-7.483V17.2a3.967 3.967 0 0 0-3.967-3.967h-5.386m-4.08-.451a3.967 3.967 0 1 1-7.934 0 3.967 3.967 0 0 1 7.934 0M22.7 5.3a3.967 3.967 0 1 1-7.934 0 3.967 3.967 0 0 1 7.934 0"
  })));
};
export default SvgGroup;